// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  mapId: __t.string(),
  name: __t.string(),
  width: __t.u32(),
  height: __t.u32(),
  gridType: __t.string(),
  seedOffsetX: __t.i32(),
  seedOffsetY: __t.i32(),
};
